/** Timezone di fallback quando la centralina non ha coordinate GPS né timezone dal sensore */
export const DEFAULT_TIMEZONE = 'UTC';
